module.exports = __webpack_public_path__ + "media/img/home/animate/arrow-540f273ac13449c0d24e6d1d9e16b39e.svg";